import React from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { findImage } from 'utils/Utils';

export interface Currencies {
  selectedCurrency: string;
  selectedValue: number;
  requestCurrency: string;
  requestValue: number;
}

const PriceContent = ({
  selectedCurrency,
  selectedValue,
  requestCurrency,
  requestValue,
}: Currencies) => {
  const { t, i18n } = useTranslation();

  return (
    <Content>
      <Info>
        <Middle>
          <Title>{t('total_amount')}</Title>
          {selectedValue === 0 ? (
            <Price>{`${requestValue.toLocaleString('en-US')} ${
              requestCurrency === 'KRW' ? t('KRW') : requestCurrency
            }`}</Price>
          ) : (
            <Price>
              {requestCurrency === selectedCurrency
                ? `${requestValue.toLocaleString('en-US')} ${
                    requestCurrency === 'KRW' ? t('KRW') : requestCurrency
                  }`
                : `${selectedValue.toLocaleString(
                    'en-US',
                  )} ${selectedCurrency} (${requestValue.toLocaleString(
                    'en-US',
                  )} ${
                    requestCurrency === 'KRW' ? t('KRW') : requestCurrency
                  })`}
            </Price>
          )}
        </Middle>
      </Info>
      <LogoShape>
        <LogoMiddle>
          <img src={findImage('logo-shape.png')} alt="Logo" />
        </LogoMiddle>
      </LogoShape>
    </Content>
  );
};

const Content = styled.div`
  width: 100%;
  height: 80px;
  background: #163b6a;
  padding: 0 30px;
  box-sizing: border-box;
  overflow: hidden;

  @media only screen and (max-width: 767px) {
    height: 60px;
    padding: 0 20px;
  }
`;

const Info = styled.div`
  float: left;
  width: 100%;
  position: absolute;

  @media only screen and (max-width: 767px) {
    width: calc(100% - 90px);
  }
`;

const Middle = styled.div`
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
  height: 80px;

  @media only screen and (max-width: 767px) {
    height: 60px;
  }
`;

const Title = styled.div`
  font-size: 14px;
  color: #fff;

  @media only screen and (max-width: 767px) {
    font-size: 12px;
  }
`;

const Price = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-top: 3px;

  @media only screen and (max-width: 767px) {
    font-size: 18px;
  }
`;

const Currency = styled.span`
  font-size: 24px;
  color: #fff;

  @media only screen and (max-width: 767px) {
    font-size: 11px;
  }
`;

const LogoShape = styled.div`
  float: right;
  width: 135px;

  @media only screen and (max-width: 767px) {
    width: 90px;
  }
`;

const LogoMiddle = styled.div`
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
  height: 80px;

  img {
    width: 90%;
    margin-top: -20px;
    opacity: 0.25;

    @media only screen and (max-width: 767px) {
      width: 90%;
      margin-top: -10px;
    }
  }

  @media only screen and (max-width: 767px) {
    height: 60px;
  }
`;

export default PriceContent;
